module.exports = __webpack_public_path__ + "static/media/crispo-logo.bbce548f.png";